import * as ActionTypes from "./ActionTypes";

//saga
//utils

export const showModal = (msg, show) => {
  return {
    type: ActionTypes.ACTIVATE_MODAL,
    msg,
    show,
  };
};
//store

export const userAuthSaga = () => {
  return {
    type: ActionTypes.IS_AUTH_SAGA,
    
  };
};

export const userAuthReducer = (isAuth, userInfo) => {
  return {
    type: ActionTypes.IS_AUTH_REDUCER,
    isAuth,
    userInfo,
  };
};
